module.exports = __webpack_public_path__ + "static/media/bg_desti.ffee731a.jpg";